import {API_BASE_URL} from './apiConfig';
export function startClientDiagnostics():()=>void {
  let sent=0;const report=(code:'frontend_unhandled'|'frontend_rejection')=>{
    if(sent>=10 || typeof fetch!=='function')return;sent+=1;
    const path=window.location.pathname;
    const surface=path==='/body-pose-mocap'?'body':path==='/capture'?'face':path==='/login'?'auth':path==='/plans'?'billing':'other';
    void fetch(`${API_BASE_URL}/api/diagnostics/client-error`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({code,surface}),credentials:'omit',keepalive:true}).catch(()=>{});
  };
  const error=()=>report('frontend_unhandled');const rejection=()=>report('frontend_rejection');
  window.addEventListener('error',error);window.addEventListener('unhandledrejection',rejection);
  return()=>{window.removeEventListener('error',error);window.removeEventListener('unhandledrejection',rejection);};
}
